import React from "react";
import cls from "classnames";

import flag from "./flag.module.scss";

export enum FLAG_SIZE {
  Small = "small",
  Medium = "medium",
  Primary = "primary",
}

export const Flag = ({ image = "", size = FLAG_SIZE.Medium, onClick, isActive, isPrimary = false }) => {
  return (<div
      onClick={onClick}
      className={cls(flag["wrapper"], flag[size], { [flag["active"]]: isActive, [flag["primary"]]: isPrimary })}
      style={{ backgroundImage: `url(${image})`}}
    />);
};
